import { render, staticRenderFns } from "./customerfrm.vue?vue&type=template&id=5fc81362"
import script from "./customerfrm.vue?vue&type=script&lang=js"
export * from "./customerfrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports